import {inject} from "@angular/core";
import {authStore} from "../service/auth/auth.store";
import {Router} from "@angular/router";


export function logoutGuard(): boolean | Promise<boolean> {
    const auth = inject(authStore);
    const router = inject(Router);

    if (auth.isLoggedIn()) {
        auth.setRedirectUrl(router.routerState.snapshot.url);
        return new Promise ((resolve)=>auth.logout().subscribe(resolve));
    }

    return true;
}